import { render, staticRenderFns } from "./TopicType.vue?vue&type=template&id=0e9e9406&"
import script from "./TopicType.vue?vue&type=script&lang=js&"
export * from "./TopicType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports